import { useEffect, useState } from "react";
import { Package, ShoppingCart, TrendingUp, AlertTriangle, Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import api, { formatPrice, formatApiError } from "../../lib/api";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [notif, setNotif] = useState(null);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/admin/orders").then(({ data }) => setOrders(data.slice(0, 6))).catch(() => {});
    api.get("/admin/notify/status").then(({ data }) => setNotif(data)).catch(() => {});
  }, []);

  const sendTest = async () => {
    setTesting(true);
    try {
      await api.post("/admin/notify/test");
      toast.success("Sınaq bildirişi göndərildi — telefonunuzu yoxlayın");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setTesting(false);
    }
  };

  const cards = [
    { label: "Məhsullar", value: stats?.total_products ?? "—", icon: Package },
    { label: "Sifarişlər", value: stats?.total_orders ?? "—", icon: ShoppingCart },
    { label: "Gəlir", value: stats ? formatPrice(stats.revenue) : "—", icon: TrendingUp },
    { label: "Az stok", value: stats?.low_stock ?? "—", icon: AlertTriangle },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif font-light text-3xl sm:text-4xl tracking-tight mb-6 sm:mb-8">Panel</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-10 sm:mb-12">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-brand-line rounded-md p-4 sm:p-6">
            <c.icon size={22} strokeWidth={1.5} className="text-brand-muted mb-4" />
            <p className="overline">{c.label}</p>
            <p className="font-serif text-2xl sm:text-3xl mt-1 break-words">{c.value}</p>
          </div>
        ))}
      </div>

      {/* Sifariş gecikməsin deyə bildirişin işlədiyi görünsün. */}
      {notif && (
        <div className="bg-white border border-brand-line rounded-md p-4 sm:p-5 mb-10 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            {notif.configured
              ? <Bell size={20} strokeWidth={1.5} className="text-brand-oxid" />
              : <BellOff size={20} strokeWidth={1.5} className="text-destructive" />}
            <div>
              <p className="text-sm font-medium">
                {notif.configured ? "Sifariş bildirişi aktivdir" : "Sifariş bildirişi qurulmayıb"}
              </p>
              <p className="text-xs text-brand-muted mt-0.5">
                {notif.configured
                  ? `Ödəniş tamamlanan kimi Telegram-a mesaj gedir (${notif.recipients} alıcı).`
                  : "Hazırda sifarişdən yalnız admin panelə baxanda xəbər tutursunuz."}
              </p>
            </div>
          </div>
          {notif.configured && (
            <button
              onClick={sendTest}
              disabled={testing}
              data-testid="notify-test-btn"
              className="border border-brand-line px-4 py-2.5 text-sm rounded-md hover:bg-brand-bg2 disabled:opacity-50"
            >
              {testing ? "Göndərilir..." : "Sınaq bildirişi göndər"}
            </button>
          )}
        </div>
      )}

      <h2 className="font-serif text-2xl mb-4">Son sifarişlər</h2>
      <div className="bg-white border border-brand-line rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[520px]">
          <thead>
            <tr className="border-b border-brand-line text-left">
              <th className="px-5 py-3 overline">Nömrə</th>
              <th className="px-5 py-3 overline">Müştəri</th>
              <th className="px-5 py-3 overline">Cəmi</th>
              <th className="px-5 py-3 overline">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-brand-line last:border-0 hover:bg-brand-bg2">
                <td className="px-5 py-3 font-mono text-xs">{o.order_number}</td>
                <td className="px-5 py-3">{o.customer?.name}</td>
                <td className="px-5 py-3">{formatPrice(o.total)}</td>
                <td className="px-5 py-3">{o.status}</td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan={4} className="px-5 py-8 text-center text-brand-muted">Sifariş yoxdur</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
